/*
 * MN — Índice de materiales de la página Cuidados.
 *
 * Marcado en `snippets/mn-care-index.liquid`, estilos en la sección 13 de
 * `assets/custom-overrides.css`. Ahí está explicado por qué esto no se puede
 * resolver en Liquid.
 *
 * Resumen: los apartados viven en secciones `multirow` distintas, y en Shopify
 * una sección no puede leer el contenido de otra. Así que la lista se arma en
 * el navegador a partir de las anclas que `sections/multirow.liquid` deja en
 * cada fila (`id` + `data-mn-anchor-label`).
 *
 * Se recorre el DOM en orden de documento, así que el índice sale en el mismo
 * orden en que aparecen los apartados en la página. Si alguien reordena las
 * secciones desde el editor, el índice se reordena solo.
 */

(function () {
  function build() {
    const nav = document.querySelector('.mn-care-index');
    if (!nav) return;

    const list = nav.querySelector('.mn-care-index__list');
    if (!list) return;

    /* `querySelectorAll` devuelve los elementos en orden de documento, que es
       justo el orden en que se leen en la página. No hay que ordenar nada. */
    const anchors = document.querySelectorAll('[data-mn-anchor-label][id]');
    if (!anchors.length) return;

    const fragment = document.createDocumentFragment();

    anchors.forEach((anchor) => {
      const label = anchor.dataset.mnAnchorLabel;
      if (!label) return;

      const item = document.createElement('li');
      const link = document.createElement('a');

      link.href = `#${anchor.id}`;
      link.className = 'mn-care-index__link';
      // `textContent` y no `innerHTML`: la etiqueta viene de un ajuste que se
      // escribe en el editor, y no hay motivo para interpretarla como HTML.
      link.textContent = label;

      item.appendChild(link);
      fragment.appendChild(item);
    });

    if (!fragment.childElementCount) return;

    list.appendChild(fragment);
    nav.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
